/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './trimester-observation.reducer';

export const TrimesterObservationDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const trimesterObservationEntity = useAppSelector(state => state.trimesterObservation.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="trimesterObservationDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.trimesterObservation.detail.title">TrimesterObservation</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.trimesterObservation.id">Id</Translate>
            </span>
          </dt>
          <dd>{trimesterObservationEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.trimesterObservation.active">Active</Translate>
            </span>
          </dt>
          <dd>{trimesterObservationEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="draft">
              <Translate contentKey="tinyMedicRestApp.trimesterObservation.draft">Draft</Translate>
            </span>
          </dt>
          <dd>{trimesterObservationEntity.draft ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.trimesterObservation.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{trimesterObservationEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.trimesterObservation.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{trimesterObservationEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.trimesterObservation.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{trimesterObservationEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.trimesterObservation.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{trimesterObservationEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.trimesterObservation.trimester">Trimester</Translate>
          </dt>
          <dd>{trimesterObservationEntity.trimester ? trimesterObservationEntity.trimester.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.trimesterObservation.labPrescription">Lab Prescription</Translate>
          </dt>
          <dd>{trimesterObservationEntity.labPrescription ? trimesterObservationEntity.labPrescription.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.trimesterObservation.vitals">Vitals</Translate>
          </dt>
          <dd>{trimesterObservationEntity.vitals ? trimesterObservationEntity.vitals.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.trimesterObservation.appointment">Appointment</Translate>
          </dt>
          <dd>{trimesterObservationEntity.appointment ? trimesterObservationEntity.appointment.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.trimesterObservation.patient">Patient</Translate>
          </dt>
          <dd>{trimesterObservationEntity.patient ? trimesterObservationEntity.patient.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.trimesterObservation.pregnancy">Pregnancy</Translate>
          </dt>
          <dd>{trimesterObservationEntity.pregnancy ? trimesterObservationEntity.pregnancy.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/trimester-observation" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/trimester-observation/${trimesterObservationEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default TrimesterObservationDetail;
